import React from "react";
import type { ButtonToggleGroupProps } from "../../../ButtonToggleGroup";
import { ButtonToggleGroup } from "../../../ButtonToggleGroup";
import FormInputWrapper from "../FormInputWrapper";
import { type ControlledFormInputProps } from "../types";

type ControlledButtonToggleGroupInputProps =
  ControlledFormInputProps<ButtonToggleGroupProps>;

const ControlledButtonToggleGroupInput = (
  props: ControlledButtonToggleGroupInputProps
) => (
  <FormInputWrapper
    {...props}
    as={ButtonToggleGroup}
  />
);

export default ControlledButtonToggleGroupInput;
